import {
	type ProethicaTestKind,
	proethicaTestDescriptors,
} from "../proethica-tests";

// SUMMATIVE/PRACTICE_TEST create-params for the live pre/post-test sessions.
export const proethicaTestSessionConfig = {
	projectId: 26,
	organizationId: 24,
	sessionType: "SUMMATIVE",
	sessionSubType: "PRACTICE_TEST",
} as const;

const collectionIdByKind = Object.fromEntries(
	proethicaTestDescriptors.map((test) => [test.kind, test.collectionId]),
) as Record<ProethicaTestKind, number>;

export const getProethicaTestCreateParams = (kind: ProethicaTestKind) => ({
	...proethicaTestSessionConfig,
	collectionId: collectionIdByKind[kind],
});
